import LogisticsCompany from "@/enum/LogisticsCompany";

/** 淘系套壳快递公司 */
export const TbLogisticsCompanies = [
    LogisticsCompany.GGSJJJ,
    LogisticsCompany.TTWLDD,
    LogisticsCompany.TTWLKD,
    LogisticsCompany.TTSX,
    LogisticsCompany.ALIWL,
    LogisticsCompany.ALIWLDD,
    LogisticsCompany.ALIHY,
];

// 快递公司识别函数
export function identifyExpressCompany(waybillNo: string) {
    if (!waybillNo) return null;

    if (waybillNo.startsWith("YT")) {
        return LogisticsCompany.YTO;
    }

    if (waybillNo.startsWith("SF")) {
        return LogisticsCompany.SF;
    }

    if (waybillNo.startsWith("DPK")) {
        return LogisticsCompany.DBKD;
    }

    if (waybillNo.startsWith("ZYJ")) {
        return LogisticsCompany.ZY;
    }

    if (waybillNo.startsWith("JD")) {
        return LogisticsCompany.JD_EXPRESS;
    }

    if (waybillNo.startsWith("JT")) {
        return LogisticsCompany.JT;
    }

    if (waybillNo.startsWith("KY")) {
        return LogisticsCompany.KUAYUE;
    }

    const length = waybillNo.length;

    if (length === 14) {
        if (waybillNo.startsWith("75") || waybillNo.startsWith("73")) {
            return LogisticsCompany.ZTO;
        }
    }

    if (length === 15) {
        if (waybillNo.startsWith("31") || waybillNo.startsWith("43")) {
            return LogisticsCompany.YUNDA;
        }
    }

    if (length === 13 && waybillNo.startsWith("9")) {
        return LogisticsCompany.POSTB;
    }

    if (length === 13 && waybillNo.startsWith("1")) {
        return LogisticsCompany.POSTS;
    }

    if (length === 13 && waybillNo.startsWith("8")) {
        return LogisticsCompany.EYB;
    }

    if (length === 12 && waybillNo.startsWith("300")) {
        return LogisticsCompany.ANE56;
    }

    if (length === 15 && waybillNo.startsWith("77")) {
        return LogisticsCompany.STO;
    }

    return null;
}
